import { render } from "./TechItsCoreValuesComp.vue?vue&type=template&id=74cb84ab&scoped=true"
import script from "./TechItsCoreValuesComp.vue?vue&type=script&lang=js"
export * from "./TechItsCoreValuesComp.vue?vue&type=script&lang=js"

import "./TechItsCoreValuesComp.vue?vue&type=style&index=0&id=74cb84ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74cb84ab"]])

export default __exports__